














import { Component, Prop, Vue } from 'vue-property-decorator';
import { AllergenDto } from '@/api';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {},
})
export default class AllergensView extends Vue {
  @Prop({required: true})
  public allergens!: AllergenDto[];

  @Prop({required: true})
  private isTraces!: boolean;

  public allergenSubHeader(): TranslateResult {
    if (this.isTraces) {
      return this.$t('message.detail.allergens.traces');
    } else {
      return this.$t('message.detail.allergens.contained');
    }
  }

  public allergenLabel(allergen: AllergenDto): TranslateResult {
    return this.$t('message.detail.allergens.keys.' + allergen.toString().toLowerCase());
  }

  public getAllergenIconPath(allergen: AllergenDto) {
    try {
      return require(`@/assets/allergens/${allergen.toString()}.png`);
    } catch (error) {
      return '';
    }
  }
}
